import { CmpButton } from "../../Component/Common/ToolBox/ToolBox";
import Grid from "@mui/material/Grid";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";

import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";

import {
  ErrorMsgDetail,
  GetItemFullSearchArr,
  fItemCodeDependency,
  GetSearchItem,
  GetUnitArr,
  fValidationDetail_Client,
  fValidationHead_Client,
  //item
  GCToggleSearch_ItemName_Columns,
  GCToggleSearch_ItemName_Select_Arr,

  //save
  fSaveHead,
  fLoad_Grid,
  fSaveApi,
} from "./PhysicalStockAction";
import {
  fAlertToast,
  fcovertToNumber,
  GetCheck_Monthend_DueDate,
  fcheck_null_undefine_replace_empty,
  GetGitterColumns,
} from "../../Utility/Utilitys";

import {
  InventoryPhysicalstock_deleteDetail_API,
  InventoryPhysicalstock_delete_API,
  common_locaitonlist_API,
} from "../../Server/ApiV2";
import {
  Set_SlicePhysicalStock_HeadObj,
  Set_SlicePhysicalStock_HeadObj_Init,
  Set_SlicePhysicalStock_HeadObj_New_Set,
} from "./SlicePhysicalStock";
import React, { useState, useEffect, useRef, useCallback } from "react";

import { useDispatch } from "react-redux";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import InstantPickingBreadcrumbs from "./PhysicalStock_BreadCrumbs";
import WmsHead from "./processComponent/WmsHead";
import WmsContent from "./processComponent/WmsContent";

import "./PhysicalStock.css";
import useMediaQuery from "@mui/material/useMediaQuery";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";
import { PhysicalStockDetailTblCard } from "./processComponent/PhysicalStockDetailTblCard";

export default function PhysicalStockDetail() {
  const dispatch = useDispatch();
  const BarcodeFocusOnLoad = useRef(null);
  const vMediaQuery = useMediaQuery("(max-width:650px)");

  const vRdxHead = useSelector(
    (state) => state.SlicePhysicalStock.value.HeadObj
  );
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const [sLocation, setLocation] = useState([]);
  const sEnterKeyObj = {
    key: "Enter",
  };
  const vInitHeadError = {
    SheetNo: "",
    Loc: "",
    LocName: "",
    Date: "",
    ReferenceNo: "",
  };
  const [sErrorMsg, setErrorMsg] = useState({
    SheetNo: "",
    Loc: "",
    LocName: "",
    Date: "",
    ReferenceNo: "",
  });
  const fLocation = async (e) => {
    dispatch(
      Set_SlicePhysicalStock_HeadObj({
        ...vRdxHead,
        Loc: e.target.value,
      })
    );
  };
  const fReferenceNo = async (e) => {
    dispatch(
      Set_SlicePhysicalStock_HeadObj({
        ...vRdxHead,
        ReferenceNo: e.target.value,
      })
    );
  };

  const fReferenceNo_Enter = (e) => {
    if (e.key === "Enter") {
      document.getElementsByName("B_Barcode")[0]?.focus();
    }
  };

  const fDate = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      dispatch(
        Set_SlicePhysicalStock_HeadObj({
          ...vRdxHead,
          Date: "",
        })
      );
    } else {
      dispatch(
        Set_SlicePhysicalStock_HeadObj({
          ...vRdxHead,
          Date: event?.$d,
        })
      );
    }
    // dispatch(
    //   Set_SlicePhysicalStock_HeadObj({
    //     ...vRdxHead,
    //     Date: event.$d,
    //   })
    // );
  };

  const [sErrorMsgDetail, setErrorMsgDetail] = useState(ErrorMsgDetail);

  const [sDetail_Grid_Row, setDetail_Grid_Row] = useState([]);
  const sRoundingVal = 4;
  const fDetail_Grid_onRowClick = async (item) => {
    setBufferObj((obj) => ({
      ...obj,
      B_Srno: item.row.B_SrNo,
      B_Barcode: item.row.B_Barcode,
      B_Itmcd: item.row.B_ItmCd,
      B_ItmName: item.row.ItmName,
      B_Qty: item.row.B_Qty,
      SuppRefNo1: item.row.B_RefNo,
      shelfNo: item.row.B_RefNo,
    }));
    let currentUnitArr = await GetUnitArr(item.row.B_ItmCd, setUnit);
    let vUnitvalue = currentUnitArr.find((obj) => {
      return obj.Unit === item.row.B_Unit;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: vUnitvalue?.Unit,
      B_UnitName: vUnitvalue?.Name1,
      B_PackQty: vUnitvalue?.PackQty,
      B_Packing: vUnitvalue.PackDesc,
    }));
    fCloseViewModal();
  };

  let vBufferObjInit = {
    B_Srno: 0, // int
    B_Barcode: "",
    B_Itmcd: "",
    B_ItmName: "",
    B_BinCode: "",
    B_BinName: "",
    B_Qty: 0,
    B_Unit: "",
    B_UnitName: "",
    B_PackQty: (0).toFixed(sRoundingVal), //Decimal
    B_Packing: 0, //Decimal
    B_BaseQty: 0, //Decimal
    SuppRefNo1: "",
    shelfNo: 0,
  };

  const [sBufferObj, setBufferObj] = useState({
    B_Srno: 0, // int
    B_Barcode: "",
    B_Itmcd: "",
    B_ItmName: "",
    B_BinCode: "",
    B_BinName: "",
    B_Qty: 0,
    B_Unit: "",
    B_UnitName: "",
    B_PackQty: (0).toFixed(sRoundingVal), //Decimal
    B_Packing: 0, //Decimal
    B_BaseQty: 0, //Decimal
    SuppRefNo1: "",
    shelfNo: 0,
  });

  const [sUnit, setUnit] = useState([]);
  const fContent_Focus = (e) => {
    if (Number(e.target.value) === 0) {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: "",
      }));
    }
  };

  const fContent_Blur = (e) => {
    if (e.target.value === "") {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: (0).toFixed(2),
      }));
    }
  };
  const fUnit = async (e) => {
    let vUnitvalue = sUnit.find((obj) => {
      return obj.Unit === e.target.value;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: vUnitvalue?.Unit,
      B_UnitName: vUnitvalue?.Name1,
      B_PackQty: vUnitvalue?.PackQty,
      B_Packing: vUnitvalue?.PackDesc,
    }));
  };

  const fQty = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_Qty: e.target.value,
    }));
  };
  const fQty_Enter = (e) => {
    if (e.key === "Enter") {
      fSave();
      document.getElementsByName("B_Qty")[0].blur();
    }
  };
  const fShelfNo_Enter = (e) => {
    if (e.key === "Enter") {
      fSave();
      document.getElementsByName("shelfNo")[0].blur();
    }
  };
  const fBarcode = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_Barcode: e.target.value,
    }));
  };
  const fShelfNo = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      shelfNo: e.target.value,
    }));
  };
  const fBarcode_BackSpace_Clear = () => {
    setBufferObj((obj) => ({
      ...obj,
      B_Itmcd: "",
      B_ItmName: "",
      B_Unit: "",
      B_PackQty: 0,
      B_BaseQty: 0,
      B_Packing: 0,
      B_Qty: 0,
      shelfNo: 0,
    }));
    setUnit([]);
  };

  //API NOTIFICATION_PICKINGBarcodeSEARCH_GETROW
  const GetBarcodeDetail = async (xBarcode) => {
    let vItemSearchFull = await GetItemFullSearchArr(xBarcode, vRdxHead.Loc);

    if (vItemSearchFull.length > 0) {
      fItemCodeDependency(vItemSearchFull, setBufferObj, setUnit);
    } else {
      fAlertToast("FAILED", "Wrong Barcode");
    }
  };

  const fBarcodeEnter = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      if (sBufferObj.B_Barcode === "") {
        fAlertToast("FAILED", "Barcode is empty");
      } else {
        GetBarcodeDetail(sBufferObj.B_Barcode);
      }
    } else if (e.key === "Backspace") {
      fBarcode_BackSpace_Clear();
    }
  };

  //Modal ItemSearch start
  const [
    GCToggleSearch_ItemName_Grid_Row,
    set_GCToggleSearch_ItemName_Grid_Row,
  ] = useState([]);
  //Item Dropdowm
  const [GCToggleSearch_ItemName_Toggle, set_GCToggleSearch_ItemName_Toggle] =
    useState(false);
  const [GCToggleSearch_ItemName_Obj, set_GCToggleSearch_ItemName_Obj] =
    useState({
      Type: "Any",
      Data: "",
    });
  const Toggle_ItemSearch = () => {
    if (GCToggleSearch_ItemName_Toggle) {
      set_GCToggleSearch_ItemName_Toggle(false);
      set_GCToggleSearch_ItemName_Grid_Row([]);
      set_GCToggleSearch_ItemName_Obj({
        Type: "Any",
        Data: "",
      });
    } else {
      set_GCToggleSearch_ItemName_Toggle(true);
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
    }
  };

  const GCToggleSearch_ItemName_Sub_Input = (e) => {
    set_GCToggleSearch_ItemName_Obj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const fItemToggleClick = (e) => {
    set_GCToggleSearch_ItemName_Grid_Row([]);
    set_GCToggleSearch_ItemName_Obj((obj) => ({
      ...obj,
      Data: sBufferObj.B_ItmName,
    }));

    if (sBufferObj.B_ItmName != "") {
      GetSearchItem(
        sBufferObj.B_ItmName,
        "Any",
        vRdxHead.Loc,
        set_GCToggleSearch_ItemName_Grid_Row
      );
    }

    Toggle_ItemSearch();
  };

  //ItemSearch
  const GCToggleSearch_ItemName_Main_Enter = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      let vItemSearchFull = await GetItemFullSearchArr(
        sBufferObj.B_ItmName,
        vRdxHead.Loc
      );

      if (vItemSearchFull.length > 0) {
        fItemCodeDependency(vItemSearchFull, setBufferObj, setUnit);
      } else {
        fItemToggleClick(e);
      }
    } else if (e.key === "Backspace") {
      setBufferObj((obj) => ({
        ...obj,
        B_Itmcd: "",
        B_ItmName: e.target.value,
        B_Barcode: "",
        B_Unit: "",
        B_UnitName: "",
        B_PackQty: "",
      }));
      setUnit([]);
    }
  };

  //Item search Start
  const GCToggleSearch_ItemName_Main_Input = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_ItmName: e.target.value,
    }));
  };

  const GCToggleSearch_ItemName_RowClick = async (e) => {
    let vItemSearchFull = await GetItemFullSearchArr(e.row.ItmCd, vRdxHead.Loc);
    if (vItemSearchFull.length > 0) {
      fItemCodeDependency(vItemSearchFull, setBufferObj, setUnit);
      document.getElementsByName("B_Qty")[0]?.focus();
    } else {
      document.getElementsByName("B_ItmName")[0]?.focus();
    }
    set_GCToggleSearch_ItemName_Toggle(false);
  };
  //GCItemSearch
  const GCToggleSearch_ItemName_CellClick = async (newSelectionModel, e) => {
    if (e.key === "Enter") {
      GCToggleSearch_ItemName_RowClick(newSelectionModel);
    }
  };
  const GCToggleSearch_ItemName_Sub_Enter = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      GetSearchItem(
        GCToggleSearch_ItemName_Obj.Data,
        GCToggleSearch_ItemName_Obj.Type,
        vRdxHead.Loc,
        set_GCToggleSearch_ItemName_Grid_Row
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };
  //Item search end

  let timeout = null;
  const fSave = async (e) => {
    clearTimeout(timeout);
    fClearErrorMsg();
    timeout = setTimeout(async () => {
      if (vRdxHead?.A_DocStat !== "ENTER") {
        fAlertToast(
          "FAILED",
          "Not allowed in " + vRdxHead?.A_DocStat + " mode"
        );
        return;
      }

      let validation = fValidationHead_Client(
        vRdxHead,
        setErrorMsg,
        vMediaQuery,
        fSummary
      );

      if (!validation) return;

      let validationDetil = fValidationDetail_Client(
        sBufferObj,
        setErrorMsgDetail
      );

      if (!validationDetil) return;

      fSaveApi(true, sBufferObj, dispatch, setDetail_Grid_Row);
      setBufferObj(vBufferObjInit);
      setUnit([]);
      document.getElementsByName("B_Barcode")[0]?.focus();
    }, 500);
  };

  const fApprove = async (e) => {
    fClearErrorMsg();
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (sBufferObj.B_Itmcd !== "") {
        fAlertToast("FAILED", "Please save current line item before approve");
        return;
      }

      if (sDetail_Grid_Row.length === 0) {
        fAlertToast("INFO", "Add atleast one line item");
        return;
      }
      let validation = fValidationHead_Client(
        vRdxHead,
        setErrorMsg,
        vMediaQuery,
        fSummary
      );

      if (!validation) return;

      let CheckDueDate = await GetCheck_Monthend_DueDate(
        vRdxHead.Loc,
        vRdxHead.Date
      );
      if (!CheckDueDate) return;

      //  let iValidateHeadApprove = await GetValidateHead_Server(
      //     dispatch,
      //     true //xapprove true in approve
      //   );

      // if (!iValidateHeadApprove) return;

      fSaveApi(false, sBufferObj, dispatch, setDetail_Grid_Row);
    }, 500);
  };

  const fClearErrorMsg = () => {
    setErrorMsg(vInitHeadError);
    setErrorMsgDetail(ErrorMsgDetail);
  };

  const fNew = async () => {
    fClearErrorMsg();
    if (sBufferObj.B_ItmName === "") {
      // fNewHead();
      fNewDetail();
      document?.getElementsByName("ReferenceNo")[0]?.focus();
    } else {
      fNewDetail();
    }
  };
  //Modal View
  const [sViewModal, setViewModal] = useState(false);
  const fView = () => {
    setViewModal(true);
  };

  const fCloseViewModal = (e) => {
    setViewModal(false);
  };
  //Modal View
  const [sSummaryModal, setSummaryModal] = useState(false);
  const fSummary = () => {
    setSummaryModal(true);
  };

  const fCloseSummaryModal = (e) => {
    setSummaryModal(false);
  };

  const fNewHead = async () => {
    dispatch(Set_SlicePhysicalStock_HeadObj_Init()); // Head Clearing

    // Setting Initial List Box 0th Object
    dispatch(
      Set_SlicePhysicalStock_HeadObj_New_Set({
        SheetNo: 0,
        Loc: sLocation[0]?.UId,
        Date: new Date(),
        ReferenceNo: "",
      })
    );
    setDetail_Grid_Row([]);
    setBufferObj(vBufferObjInit);
  };

  //vTaxType  vTaxType ==  sTax[1].Uid then tax %0
  const fNewDetail = () => {
    setBufferObj(vBufferObjInit);

    setUnit([]);

    fLoad_Grid(vRdxHead.SheetNo, setDetail_Grid_Row);

    document.getElementsByName("B_Barcode")[0]?.focus();
  };

  const fDelete = (e) => {
    if (vRdxHead.A_DocStat === "POST") {
      fAlertToast("FAILED", "You are not allowed to delete in post status");
      return;
    } else if (sBufferObj.B_Srno === 0) {
      fAlertToast("FAILED", "Item not selected");
      return;
    } else {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete line item.",
        buttons: [
          {
            className: "alertBtn",
            label: "Yes",
            onClick: () => {
              fDeleteDetail();
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
    }
  };

  //DELETESIDETAIL_GETROW
  const fDeleteDetail = async () => {
    let vDeleteSIDetailObj = {
      TrnTyp: "IPT01",
      A_SheetId: vRdxHead.SheetNo,
      A_RefNo: vRdxHead.ReferenceNo,
      B_SrNo: sBufferObj.B_Srno,
      A_UsedCd: vRdxuserInfo.UserID,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vDeleteSIDetailObj);
    const vDeleteSIDetail = await InventoryPhysicalstock_delete_API(FinalObj);

    if (vDeleteSIDetail?.status === 200) {
      fAlertToast("SUCCESS", "Successfully Deleted Line Item");
      fNewDetail();
    }
  };
  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };
  const fPrint = useCallback(
    (xPrnTyp) => {
      let urlPrint =
        vRdxDBKernObj?.WEB_REPORT_BASE_URL?.Val +
        "WMS/PhysicalStock?prntyp=" +
        xPrnTyp +
        "&sheet=" +
        vRdxHead.SheetNo;
      setWebReportUrlModal(urlPrint);
      fWebReport();
    },
    [vRdxHead.SheetNo, vRdxDBKernObj]
  );

  //esc keyZ close item dropdown
  const escFunction = useCallback((event) => {
    if (event.key === "Escape") {
      set_GCToggleSearch_ItemName_Toggle(false);
      set_GCToggleSearch_ItemName_Grid_Row([]);
    }
  }, []);

  useEffect(() => {
    const handleClick = (event) => {
      if (GCToggleSearch_ItemName_Toggle) {
        const toggleElement = event.target.closest(".toggleSearch");

        if (!toggleElement) {
          set_GCToggleSearch_ItemName_Toggle(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [GCToggleSearch_ItemName_Toggle]);

  useEffect(() => {
    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty: fcovertToNumber(sBufferObj.B_Qty * sBufferObj.B_PackQty),
    }));
  }, [sBufferObj.B_Qty, sBufferObj.B_PackQty]);

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);

    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, [escFunction]);

  const getLocation = useCallback(async () => {
    let locationObj = {
      usercd: vRdxuserInfo.UserID,
    };
    let locationList = await common_locaitonlist_API(locationObj);
    if (locationList?.status === 200) {
      if (locationList.data?.ResultSet?.length > 0) {
        setLocation(locationList?.data?.ResultSet);
      }
    }
  }, [vRdxuserInfo.UserID]);

  useEffect(() => {
    getLocation();
  }, [getLocation]);

  useEffect(() => {
    if (vRdxHead.SheetNo) {
      fLoad_Grid(vRdxHead.SheetNo, setDetail_Grid_Row);
    }
  }, [vRdxHead.SheetNo]);

  useEffect(() => {
    BarcodeFocusOnLoad?.current?.focus();
  }, []);
  const [Detail_Grid_columns, setGridDataAuditColumns] = useState([
    {
      field: "B_SheetId",
      headerName: "Sheet No",
      width: 150,
      hide: vMediaQuery ? true : false,
    },
    {
      field: "B_SrNo",
      headerName: "Sr No",
      width: 50,
      hide: vMediaQuery ? true : false,
    },
    {
      field: "B_Barcode",
      headerName: "Barcode",
      width: 150,
    },

    {
      field: "B_Qty",
      headerName: "Qty",
      width: 50,
    },
    {
      field: "B_ItmCd",
      headerName: "Item Code",
      width: 90,
      hide: true,
    },
    {
      field: "ItmName",
      headerName: "Item Name",
      width: 320,
    },

    {
      field: "B_Unit",
      headerName: "Unit",
      width: 100,
    },
    {
      field: "B_BaseQty",
      headerName: "Base Qty",
      width: 100,
      hide: vMediaQuery ? true : false,
    },
  ]);

  // useEffect(() => {
  //   GetGitterColumns(
  //     setGridDataAuditColumns,
  //     "WMS_SALES_INVOICE_AUDIT",
  //     Detail_Grid_columns
  //   );

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  return (
    <Box sx={{ p: 2 }}>
      <Box mb={2}>
        <InstantPickingBreadcrumbs />
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row", lg: "row" },
          gap: 3,
        }}
      >
        <Box
          sx={{
            width: { xs: "100%", md: "40%", lg: "40%" },
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <WmsHead
            xref={BarcodeFocusOnLoad}
            vRdxHead={vRdxHead}
            xErrorMsg={sErrorMsg}
            vRdxuserLoc={sLocation}
            fLocation={fLocation}
            fReferenceNo={fReferenceNo}
            fReferenceNo_Enter={fReferenceNo_Enter}
            fDate={fDate}
            sDetail_Grid_Row={sDetail_Grid_Row}
            vMediaQuery={vMediaQuery}
          />
          <WmsContent
            sEnterKeyObj={sEnterKeyObj}
            xContent_Focus={fContent_Focus}
            xContent_Blur={fContent_Blur}
            xErrorMsgDetail={sErrorMsgDetail}
            xBufferObj={sBufferObj}
            sUnit={sUnit}
            fUnit={fUnit}
            fQty={fQty}
            fQty_Enter={fQty_Enter}
            fShelfNo_Enter={fShelfNo_Enter}
            fBarcode={fBarcode}
            fShelfNo={fShelfNo}
            fBarcodeEnter={fBarcodeEnter}
            fItemName={GCToggleSearch_ItemName_Main_Input}
            xMediaQuery={vMediaQuery}
            xonClickbtn={GCToggleSearch_ItemName_Main_Enter}
            xrows={GCToggleSearch_ItemName_Grid_Row}
            xcolumns={GCToggleSearch_ItemName_Columns}
            xRowCellClick={GCToggleSearch_ItemName_CellClick}
            xRowClick={GCToggleSearch_ItemName_RowClick}
            xToggle={GCToggleSearch_ItemName_Toggle}
            xData={GCToggleSearch_ItemName_Select_Arr}
            xOnChangeDropdownInput={GCToggleSearch_ItemName_Sub_Input}
            xDropdownObj={GCToggleSearch_ItemName_Obj}
            xOnKeyUpDropdownInput={GCToggleSearch_ItemName_Sub_Enter}
          />

          <Grid
            container
            spacing={0.5}
            sx={{
              "& .MuiButton-root": {
                fontSize: {
                  xs: "9px !important",
                  sm: "12px !important",
                  md: "14px !important",
                },
                padding: { xs: "2px 6px", sm: "4px 10px", md: "6px 14px" },
                minHeight: { xs: "28px", md: "36px" },
              },
            }}
          >
            <Grid item xs={4} sm={2} md={4}>
              <CmpButton
                xbtnName="New"
                xOnClick={fNew}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xId={"IdNew"}
                xSendIcon={<AddBoxRoundedIcon />}
              />
            </Grid>

            <Grid item xs={4} sm={2} md={4}>
              <CmpButton
                xbtnName="Save"
                xOnClick={fSave}
                xVariant="contained" // Variant (filled button)
                xColor="success" // Color (green)
                xDisabled={vRdxHead.A_DocStat !== "ENTER"}
                xSize="small"
                xId="IdSave"
                xSendIcon={<SaveRoundedIcon />}
              />
            </Grid>

            <Grid item xs={4} sm={2} md={4}>
              <CmpButton
                xbtnName="Delete"
                xOnClick={fDelete}
                xVariant="contained"
                xDisabled={vRdxHead.A_DocStat !== "ENTER"}
                xSize="small"
                xColor="error"
                xId="IdDelete"
                xSendIcon={<DeleteRoundedIcon />}
              />
            </Grid>

            <Grid
              item
              xs={4}
              sm={2}
              md={4}
              sx={{
                "& .dropdown-toggle": {
                  padding: "4px  !important",
                  fontSize: {
                    xs: "10px !important",
                    sm: "13px !important",
                    md: "16px !important",
                    lg: "16px !important",
                  },
                  width: {
                    xs: "90% !important",
                    sm: "80% !important",
                    md: "100% !important",
                    lg: "70% !important",
                  },
                },
              }}
            >
              <DropdownButton
                id="dropdown-basic-button"
                title="Print"
                variant="primary"
              >
                <Dropdown.Item onClick={() => fPrint("C")}>
                  Consolidated
                </Dropdown.Item>
                <Dropdown.Item onClick={() => fPrint("S")}>
                  Detail Simplified
                </Dropdown.Item>
                <Dropdown.Item onClick={() => fPrint("")}>Detail</Dropdown.Item>
              </DropdownButton>
            </Grid>

            <Grid item xs={4} sm={2} md={4}>
              <CmpButton
                xbtnName="Detail"
                xOnClick={fView}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xSendIcon={<RemoveRedEyeIcon />}
              />
            </Grid>

            <Grid item xs={4} sm={2} md={4}>
              <CmpButton
                xbtnName="Summary"
                xOnClick={fSummary}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xSendIcon={<RemoveRedEyeIcon />}
              />
            </Grid>
          </Grid>
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            width: { xs: "100%", md: "80%", lg: "80%" },
          }}
        >
          <PhysicalStockDetailTblCard
            data={sDetail_Grid_Row}
            onClick={fDetail_Grid_onRowClick}
            vMediaQuery={vMediaQuery}
          />
        </Box>
      </Box>

      <Modal
        open={sSummaryModal}
        onClose={fCloseSummaryModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Summary"} onClose={fCloseSummaryModal} />

          <div className="py-3">
            <WmsHead
              xref={BarcodeFocusOnLoad}
              vRdxHead={vRdxHead}
              xErrorMsg={sErrorMsg}
              vRdxuserLoc={sLocation}
              fLocation={fLocation}
              fReferenceNo={fReferenceNo}
              fReferenceNo_Enter={fReferenceNo_Enter}
              fDate={fDate}
              sDetail_Grid_Row={sDetail_Grid_Row}
              vMediaQuery={vMediaQuery}
            />
          </div>
        </Box>
      </Modal>
      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
    </Box>
  );
}
